import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'user-gifts',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'user-gifts',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'user-gifts',
  action: ActionType.UPDATE,
};

export const UserGift = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
};
